import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { SpocUserDetails, SpocUserDetailsDTO } from "../types/spocUserDetails";
/* eslint-disable import/export */
export abstract class GetProjectSpocDetailsRPC implements
  LeoRPC<GetProjectSpocDetailsRPC.Request, GetProjectSpocDetailsRPC.Response, GetProjectSpocDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetProjectSpocDetailsRPC.Request
  ): Promise<LeoRPCResult<GetProjectSpocDetailsRPC.Response, GetProjectSpocDetailsRPC.Errors.Errors>>;
}

export namespace GetProjectSpocDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetProjectSpocDetailsRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetProjectSpocDetailsRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    spocUserDetails: SpocUserDetailsDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetProjectSpocDetailsResponse: boolean = true;
  
    readonly spocUserDetails: SpocUserDetails[];
  
  
    constructor(
    spocUserDetails: SpocUserDetails[]
    ) {
      this.spocUserDetails = spocUserDetails;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const spocUserDetails = getList<SpocUserDetailsDTO, SpocUserDetails>(
        dto,
        "spocUserDetails",
        SpocUserDetails.fromDTO,
        InvalidResponseSpocUserDetailsError
      );
      return new Response(
        spocUserDetails
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          spocUserDetails: this.spocUserDetails.map((e: SpocUserDetails) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetProjectSpocDetails(spocUserDetails='${this.spocUserDetails}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetProjectSpocDetailsRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetProjectSpocDetailsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseSpocUserDetailsError extends GetProjectSpocDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSpocUserDetailsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetProjectSpocDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

